const template = `
	<div class="drop-panel" :class="classes">
		<div class="drop-panel-clickable" @click="toggle">
			<slot></slot>
		</div>
		<transition :name="anim ? 'drop-anim' : ''">
			<div v-if="active" class="drop-panel-box" :class="boxClass" ref="box" :style="boxStyle">
				<div class="drop-panel-box-inner">
					<slot name="box"></slot>
				</div>
			</div>
		</transition>
	</div>
`;

export default {
	template,
	props: {
		corner: {
			validator: val => ['top-left', 'bottom-left', 'top-right', 'bottom-right'].indexOf(val) !== -1,
			default: 'bottom-left'
		},
		dirX: {
			validator: val => ['left', 'right'].indexOf(val) !== -1,
			default: 'right'
		},
		dirY: {
			validator: val => ['bottom', 'top'].indexOf(val) !== -1,
			default: 'bottom'
		},
		anim: {
			validator: val => ['ltr', 'rtl', 'btt', 'ttb'].indexOf(val) !== -1
		},
		scrollable: {
			default: false
		},
		static: {
			default: false
		}
	},
	data() {
		return {
			active: false,
			height: 'auto'
		};
	},
	computed: {
		classes() {
			return {
				'drop-panel-scrollable': this.scrollable,
				'drop-panel-active': this.active,
				'drop-panel-static': this.static
			};
		},
		boxClass() {
			if (this.static) return;

			let anim = (this.anim ? 'anim-' + this.anim : '');
			return [this.corner, 'dir-' + this.dirX, 'dir-' + this.dirY, anim];
		},
		boxStyle() {
			let style = {
				height: this.height
			};
			return style;
		}
	},
	methods: {
		toggle() {
			if (this.static) return;

			this.active = !this.active;

			if (this.active) {
				setTimeout(() => {
					document.addEventListener('click', this.onDocClick)
				}, 100);
			} else {
				document.removeEventListener('click', this.onDocClick);
			}
		},
		close() {
			if (this.static || !this.active) return;

			this.toggle();
		},
		onDocClick(e) {
			let isInside = this.$refs.box.contains(e.target);
			if (!isInside && this.active) {
				this.toggle();
			}
		}
	},
	watch: {
		active() {
			this.$emit('change', this.active);

			this.height = 'auto';

			if (!this.active || !this.scrollable) return;

			this.$nextTick(() => {
				let box = this.$refs.box;
				if (!box) return;

				let rect = box.getBoundingClientRect();
				let shift = Math.ceil(rect.bottom - this.win.height);
				if (shift > 0) {
					this.height = (rect.height - shift) + 'px';
				} else {
					this.height = 'auto';
				}
			});
		}
	},
	mounted() {
		if (this.static) {
			this.active = true;
		}
	},
	destroyed() {
		document.removeEventListener('click', this.onDocClick);
	}
}